import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import TextField from 'components/core/TextField';
// Core components
import { TextButton, ContainedButton } from 'components/core/Button';
// Models
import { serializeGroup } from 'models/simcard';
// Custom
import { buildFormErrors, simcardGroupConstraints } from 'utils/Forms';
import withFormManagement from 'hocs/WithFormManagement';
import withEnterKeyManager from 'hocs/WithEnterKeyManager';

class GroupAddForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Check if enter key has been pressed
    const { enterPressed } = this.props;
    const { enterPressed: prevEnterPressed } = prevProps;
    if (!prevEnterPressed && enterPressed) {
      this.handleValidate();
    }
  }

  // Handlers
  handleValidate(e) {
    if (e) {
      e.preventDefault();
    }

    const {
      fields: { name },
      onErrorsChange, onValidate,
    } = this.props;

    const errors = buildFormErrors({ name }, simcardGroupConstraints);
    // Apply errors
    onErrorsChange(errors);

    // No error => validate form
    if (!errors) {
      onValidate(serializeGroup(name));
    }
  }

  render() {
    const {
      fields: { name }, errors,
      onFieldsChange, onKeyPress, onCancel,
    } = this.props;

    return (
      <div className="box box-default m-0">
        <div className="px-3 pb-3">
          <TextField
            label={<LocalizedMessage id="field.name" />}
            errorText={_get(errors, 'name')}
            value={name}
            required
            onChange={(value) => onFieldsChange({ name: value })}
            onKeyPress={onKeyPress}
          />
        </div>
        <div className="box-header box-dark d-flex justify-content-end right-spaced-buttons">
          <TextButton
            label={<LocalizedMessage id="button.cancel" />}
            onClick={onCancel}
          />
          <ContainedButton
            label={<LocalizedMessage id="button.validate" />}
            onClick={this.handleValidate}
          />
        </div>
      </div>
    );
  }
}

GroupAddForm.propTypes = {
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
  enterPressed: PropTypes.bool.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

GroupAddForm.defaultProps = {
  errors: null,
};

const mapFieldsToProps = {
  name: {
    defaultValue: '',
  },
};

module.exports = compose(
  withFormManagement(mapFieldsToProps, null, false),
  withEnterKeyManager,
)(GroupAddForm);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/groups/GroupAddForm.js